import React from "react"

function MapInfo() {
    const paperData = [
        {
            id: 0,
            color: "greenTab",
            topLine: ". 10-1-1   1-4-4   2-1-4   8-3-1 .",
            bottomLine: ". 6-1-2   14-4-1   7-1-3   2-3-2 ."
        },
        {
            id: 1,
            color: "yellowTab",
            topLine: ". 3-3-2   8-6-4   1-4-1 .",
            bottomLine: ". 6-4-1   9-4-2   2-5-4 ."
        },
        {
            id: 2,
            color: "redTab",
            topLine: ". 5-3-2   2-1-1   12-1-3 .",
            bottomLine: ". 15-4-4   4-4-2   5-6-1   6-4-3   10-1-5 ."
        },
    ]
    
    const papers = paperData.map(paper => {
        return (
            <div key={paper.id} className="mapPaperWrapper">
                <h3><mark className={paper.color}>{paper.topLine}</mark></h3>
                <h3><mark className={paper.color}>{paper.bottomLine}</mark></h3>
            </div>
        )
    })
    
    return (
        <div className="mapInfo">
            <h3>Maybe you can make sense of the seemingly random numbers she has been repeating in her NYPD interview?</h3>
            {papers}
        </div>
    )
}

export default MapInfo